import { type PartialDeep } from 'type-fest';

import {
  type ChartVariantType,
  type PropertiesConfigInputVisualEffectModel,
} from '@blaze-shared/elements-domain';

import { PropsExtractor } from '../__base/props-extractor';

export class ChartPropsExtractor extends PropsExtractor<Exclude<ChartVariantType, 'chartSingle'>> {
  override getVisualEffect: () => PartialDeep<PropertiesConfigInputVisualEffectModel> | undefined =
    () => this.props?.style?.background?.visualEffect;
}

export class ChartSinglePropsExtractor extends PropsExtractor<'chartSingle'> {
  override getVisualEffect: () => PartialDeep<PropertiesConfigInputVisualEffectModel> | undefined =
    () => this.props?.style?.background?.visualEffect;
}
